import {
  Button,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from '@chakra-ui/react'
import { Fragment } from 'react'
import { FaCheck, FaPaperclip } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import useIsAdmin from '../../../hooks/useIsAdmin'
import { diagnosisTitles } from '../../../types/FirestoreUser'
import { ProgressionQueryHit } from '../../../types/ProgressionQuery'

interface Props {
  hits: ProgressionQueryHit[]
  displayMonths: string[]
}

export default function QueryResultsTable({ hits, displayMonths }: Props) {
  const isAdmin = useIsAdmin()

  return (
    <TableContainer>
      <Table size='sm'>
        <Thead>
          <Tr>
            <Th>Patient ID</Th>
            <Th>Diagnosis</Th>
            <Td>Docs</Td>
            <Th>Name</Th>
            <Th>Net Change</Th>
            <Th>Avg/Month</Th>
            <Th>Months</Th>
          </Tr>
        </Thead>
        <Tbody>
          {hits.map((user) => {
            return (
              <Tr key={user.uid}>
                <Td>
                  {isAdmin ? (
                    <Link
                      to={`/admin/users/${user.uid}/print`}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <Button variant='link'>#{user.patientId}</Button>
                    </Link>
                  ) : (
                    `#${user.patientId}`
                  )}
                </Td>
                <Td>
                  {diagnosisTitles[user.diagnosis]} ({user.diagnosisDate})
                </Td>
                <Td>
                  <HStack spacing={1}>
                    {user.diagnosisDocumentation.length > 0 && (
                      <FaPaperclip size={20} color='black' />
                    )}
                    {user.diagnosisVerified && (
                      <FaCheck size={20} color='black' />
                    )}
                  </HStack>
                </Td>
                <Td>
                  {user.lastName}, {user.firstName}
                </Td>
                <Td>
                  {user.netChange > 0 ? '+' : ''}
                  {user.netChange}
                </Td>
                <Td>
                  <Tooltip
                    label={`From ${user.firstScoreMonth} to ${user.lastScoreMonth}`}
                  >
                    <Text cursor='pointer'>
                      {user.averagePerMonth > 0 ? '+' : ''}
                      {user.averagePerMonth.toFixed(2)}
                    </Text>
                  </Tooltip>
                </Td>
                <Td display='flex'>
                  {displayMonths.map((month, index) => {
                    return (
                      <Fragment key={month}>
                        <Tooltip label={month}>
                          <Text cursor='pointer'>
                            {user.scores.find((s) => s.month === month)
                              ?.score || '-'}
                          </Text>
                        </Tooltip>
                        {index < displayMonths.length - 1 && '/'}
                      </Fragment>
                    )
                  })}
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
